import { AdaBindMethodPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { CodeEditorModule } from '@adaptiva/widgets/code-editor';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { EditorToolbarComponentModule } from '@adaptiva/widgets/editor-toolbar';
import { FileUploaderComponentModule } from '@adaptiva/widgets/file-uploader';
import { ImageComponentModule } from '@adaptiva/widgets/image';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { ObjectTableComponentModule } from '@adaptiva/widgets/object-table';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ThemeDisplayComponentModule, ThemePreviewComponentModule } from '@adaptiva/widgets/themes';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ThemesEditorAreaComponent } from './themes-editor-area.component';

const PIPES: Type<PipeTransform>[] = [
	AdaBindMethodPipe,
];

const WIDGETS: Type<any>[] = [
	AlertComponentModule,
	ButtonComponentModule,
	CardComponentModule,
	CodeEditorModule,
	ContainerComponentModule,
	EditorToolbarComponentModule,
	FileUploaderComponentModule,
	ImageComponentModule,
	InputComponentModule,
	LabelComponentModule,
	ObjectTableComponentModule,
	OverlayComponentModule,
	TemplateMarkerDirectiveModule,
	TextComponentModule,
	ThemeDisplayComponentModule,
	ThemePreviewComponentModule,
];

@NgModule({
	imports: [
		CommonModule,
		DynamicComponentLoaderModule.forChild(ThemesEditorAreaComponent),
		FormsModule,
		PIPES,
		WIDGETS,
	],
	declarations: [ThemesEditorAreaComponent],
	exports: [ThemesEditorAreaComponent],
})
export class ThemesEditorAreaModule {

}
